export default{
  zgrupowania:[
    {
      id:0,
      name: 'Zgrupowanie nr. 1',
      participants: [
        'Garnizon miasta Wilna',
        '3 Brygada por. „Szczerbca”',
        '7 Brygada por. „Wilhelma”',
        'Oddział Partyzancki por. „Gozdawy”',
        'Oddział Rozpoznawczy Komendanta Okręgu por. „Groma”'
      ],
      img:{
        url: '/historia/powolanie_zgrupowan/antoni_olechnowicz.jpg',
        desc: 'Dowódcą Inspektoratu „A” oraz tego zgrupowania był Dypl. Mjr Antoni Olechnowicz „Podhorecki”'
      }
    },
    {
      id:1,
      name: 'Zgrupowanie nr. 2',
      participants: [
        '1 Brygada por. „Juranda”',
        '2 Brygada por. „Kaziuka”',
        '4 Brygada por. „Romina”',
        '5 Brygada por. „Łupaszki”',
        '23 Brygada por. „Ostrogi” i por. „Światołdycza”',
        '24 Brygada por. „Wawerzeckiego”',
        '36 Brygada por. „Wujka”'
      ],
      img:{
        url: '/historia/powolanie_zgrupowan/mieczyslaw_potocki.jpg',
        desc: 'Dowódca Inspektoratu „BC” oraz tego zgrupowania był Mjr.dypl. Mieczysław Potocki „Węgielny”'
      }
    },
    {
      id:2,
      name: 'Zgrupowanie nr. 3',
      participants: [
        '9 Brygada chor. „Małego” i kpt. „Gracza”',
        '10 Brygada por. „Gustawa”',
        '12 Brygada por. „Cerbera”',
        '13 Brygada „Nietoperza”',
      ],
      img:{
        url: '/historia/powolanie_zgrupowan/czeslaw_debicki.jpg',
        desc: 'Dowódca Inspektoratu „F” oraz tego zgrupowania był mjr inż. Czesław Dębicki „Jarema”'
      }
    }
  ]
}



// WEBPACK FOOTER //
// ./src/models/historia/powolanie_zgrupowan.js